export default __webpack_public_path__ + "static/media/mosaic_icon.c28511bf.svg";